import React from "react";
import { CalendarClock, MessageCircle, Phone, PhoneIncoming } from "lucide-react";
import { BUSINESS_INFO } from "../../constants/businessInfo";

const ContactCTA = ({ className = "" }) => {
  return (
    <section
      className={`rounded-2xl bg-gradient-to-r from-slate-900 to-blue-900 p-6 text-white shadow-lg ${className}`}
      aria-label="Contact Call To Action"
    >
      <h2 className="text-2xl font-semibold">Need help finding your dream property?</h2>
      <p className="mt-2 text-sm text-blue-100">
        Connect with our advisors for verified listings, transparent pricing, and guided site visits.
      </p>

      <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <ActionLink
          href={`tel:${BUSINESS_INFO.phone.replace(/\s+/g, "")}`}
          label="Call Now"
          icon={Phone}
        />
        <ActionLink
          href={`https://wa.me/${BUSINESS_INFO.whatsappNumber}`}
          label="WhatsApp"
          icon={MessageCircle}
          external
        />
        <ActionLink
          href={`https://wa.me/${BUSINESS_INFO.whatsappNumber}?text=${encodeURIComponent(
            "Hi, I want to book a site visit."
          )}`}
          label="Book Site Visit"
          icon={CalendarClock}
          external
        />
        <ActionLink
          href={`mailto:${BUSINESS_INFO.businessEmail}?subject=${encodeURIComponent(
            "Request Callback"
          )}`}
          label="Request Callback"
          icon={PhoneIncoming}
        />
      </div>
    </section>
  );
};

const ActionLink = ({ href, label, icon: Icon, external = false }) => (
  <a
    href={href}
    target={external ? "_blank" : undefined}
    rel={external ? "noopener noreferrer" : undefined}
    className="inline-flex items-center justify-center gap-2 rounded-lg border border-white/30 bg-white/10 px-4 py-3 text-sm font-medium transition hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white"
  >
    <Icon className="h-4 w-4" aria-hidden="true" />
    <span>{label}</span>
  </a>
);

export default ContactCTA;
